import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {logsList_template} from "../components/templates/logsList_template";


declare var ko: any;
declare var page: any;
declare var Waypoint: any;

export class logs extends vnModule_knockoutJS{

    protected logsList_template: logsList_template;
    protected moduleXHRHdl: XMLHttpRequestHandler;
    protected optionsBulk;


    //
    // implementation of base class [vnModule]
    protected getModuleName(): string {

        return "taskExecuterslogs";
    }

    //
    // implementation of base class [vnModule]
    buildContent(): Array<Element> {

        this.logsList_template = new logsList_template("logs", this.viewModel, this)
        return [this.logsList_template.build()];
    }

    public fillPage() : void{

        this.logsList_template.activateLoading();
        this.getFormData();
    }

    protected getFormData(){

        this.logsList_template.activateLoading();

        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.logsList_template.getViewModelForRequest())] );
        let XHRHdl = new XMLHttpRequestHandler('/api/logs/', params, this);

        XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        XHRHdl.execute();
    }

    protected onGetFormDataReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                let taskExecuters = [];
                let taskExecutersMain = responseParsed.data.taskExecutersMain;
                let taskExecutersSystems = responseParsed.data.taskExecutersSystems;

                for(let taskExecutersSystem of taskExecutersSystems){

                    taskExecutersSystem['taskExecuter'] = taskExecutersSystem['taskExecuter'] + '_SUBSYSTEM';

                    if(!taskExecutersSystem.name.endsWith('SUBSYSTEM')){

                        taskExecutersSystem['name'] = taskExecutersSystem['name'] + ' SUBSYSTEM';
                    }
                }

                taskExecuters = taskExecutersMain.concat(taskExecutersSystems);

                obj.logsList_template.setTaskExecuters(taskExecuters);
                //obj.logsList_template.setAutomaticTasks(responseParsed.data.automaticTasks);
                obj.getItems();
            });
        };
    }


    public reorderLogs(){
        this.getItems();
    }

    public taskExecuterSelect(){
        this.getItems();
    }

    protected getItems(){

        this.logsList_template.activateLoading();

        if( this.moduleXHRHdl ){
            this.moduleXHRHdl.cancelAndReset();
        }

        let vm = this.logsList_template.getViewModelForRequest();

        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON( vm )] );

        this.moduleXHRHdl = new XMLHttpRequestHandler('/api/logs/', params, this);
        this.moduleXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        let localCheck = this.moduleXHRHdl.requestId;
        let _myThis = this;
        setTimeout(function(){

            if( localCheck == _myThis.moduleXHRHdl.requestId ){

                _myThis.moduleXHRHdl.onReadyStateFunction = _myThis.onGetItemsReturn;
                _myThis.moduleXHRHdl.execute();
            }
        }, 400);
    }

    public onGetItemsReturn(req, obj: logs){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateList(responseParsed);
            });

            if(req.request.readyState == 4){

                obj.logsList_template.deactivateLoading();
            }
        }
    }

    protected updateList(responseParsed: any){

        this.logsList_template.setPageNumber(responseParsed.currentPage);
        this.logsList_template.setPagination(responseParsed.totalCount);
        this.logsList_template.setResultPage(responseParsed.totalCount);
        this.logsList_template.setLogs(responseParsed.data);
        this.logsList_template.resetTrackedLogId();

        let columnMessages = document.querySelectorAll("td");

        for (let columnMessage of columnMessages) {

            if (columnMessage.innerText.indexOf("taskExecuter:") != -1) {
                columnMessage.className = "highlight-log-taskExecuter";
            }
            if (columnMessage.innerText.indexOf("locker:") != -1) {
                columnMessage.className = "highlight-log-locker";
            }
            if (columnMessage.innerText.indexOf("statsObtainer:") != -1) {
                columnMessage.className = "highlight-log-statsObtainer";
            }
            if (columnMessage.innerText.indexOf("Error") != -1) {
                columnMessage.className = "highlight-log-error";
            }
        }

    }

    protected processSelectedAccountLogs(account){

        localStorage.setItem("accountId", account);

        if (localStorage.getItem("accountId")) {

            this.logsList_template.getTemplateViewModel().accountId(localStorage.getItem("accountId"));
        }
        this.getItems();
    }

    // required from template [logsList_template]
    protected filterSimpleOnChange(){
        this.resetPageNumber();
        this.getItems();
    }

    // required from template [logsList_template]
    protected paginationOnPageClick(){
        this.getItems();
    }

    private resetPageNumber(){
        // go back to page 1 in the pagination
        this.logsList_template.pagination.getTemplateViewModel().pageNumber(1);
    }
    protected errorHandler(req, obj): void{

        setTimeout(function(){

            obj.getVnAppZone().showNotificationToModule(new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, req.message));

            obj.logsList_template.deactivateLoading();
            console.log("ERROR");
        }, 500);

    }

    // required from template [tasksList_template]
    protected executeAction(){
        this.executeActionOnAccounts();
    }


    protected executeActionOnAccounts(){

        this.logsList_template.activateLoading();

        let vm = this.logsList_template.getViewModelForRequest();
        vm["idProperty"] = this.getVnAppZone().app.params.idProperty;
        if(localStorage.getItem("accountId")){
            vm["filters"]["accounts_selected"] = parseInt(localStorage.getItem("accountId"));
        }

        let params: Array<Array<string>> = [];
        params.push(["action", "get_execute_action"], ["data", ko.toJSON( vm )] );

        let XHRHdl = new XMLHttpRequestHandler('/includes/actions/logs.php', params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = this.getRequestReturnFunction( [{"code": 200, "function": this.onExecuteActionReturn}], this.errorHandler);
        XHRHdl.execute();
    }

    protected onExecuteActionReturn(req, obj: logs){

        if (req.data[0].cronCommand !== undefined){
            setTimeout(function(){

                //obj.getVnAppZone().addNotificationToModule(new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Actions applied with success."));
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Actions applied with success.");

                obj.logsList_template.deactivateLoading();

                obj.refreshLogList();

            }, 500);
        }
        else {
            //obj.getVnAppZone().addNotificationToModule(new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Actions applied with success."));
            obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Actions applied with success.");
            obj.logsList_template.deactivateLoading();
        }


    }

    protected refreshLogList(){
        window.location.reload(true);
        this.processSelectedAccountLogsRefresh();
    }

    protected processSelectedAccountLogsRefresh(){

        if (localStorage.getItem("accountId")) {
            this.logsList_template.getTemplateViewModel().accountId(localStorage.getItem("accountId"));
        }

        this.getItems();
    }

    public filterSimpleCancel(): void {
        console.log('filterSimpleCancel');
    }
}


// WEBPACK FOOTER //
// ./js/modules/logs.ts